import * as yup from 'yup';
import * as Schema from '../schemaFields';

export const templateStartGameValidationSchema = yup.object({
  startDate: Schema.requiredDate,
  startHour: Schema.requiredDate,
  endDate: Schema.requiredDate,
  endHour: Schema.endDateTimeAfterStart,
  numOfPlayers: Schema.requiredNumber,
});
